<div>
  <img src="{{ url }}" alt="" />
</div>
